import { CustomButton, Text } from '../index';
import './styles.scss';

interface PopupNavigationProps {
	currentIndex: number;
	onNext: () => void;
	onPrevious: () => void;
	totalCount: number;
}

const PopupNavigation = ({ currentIndex, totalCount, onPrevious, onNext }: PopupNavigationProps) => {
	const isFirst = currentIndex === 0;
	const isLast = currentIndex === totalCount - 1;
	const displayIndex = currentIndex + 1; // Show 1-based index to user

	return (
		<div className="popupNavigation">
			<CustomButton title="Previous" onClick={onPrevious} disabled={isFirst} buttonType="outlined" />
			<Text title={`${displayIndex} OF ${totalCount}`} type="plg" fontWeight="semiBold" />
			<CustomButton title="Next" onClick={onNext} disabled={isLast} buttonType="outlined" />
		</div>
	);
};

export default PopupNavigation;
